import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "@phosphor-icons/react";

const LegalPage = ({ title, updated, sections, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid={testId} className="min-h-screen bg-white text-ink antialiased">
      <header className="border-b border-black/5 bg-cream/60">
        <div className="max-w-4xl mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid={`${testId}-logo`} aria-label="Network in Colors, back to home">
            <img src="/assets/logo.webp" alt="Network in Colors" className="h-10 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid={`${testId}-back-link`}
            className="inline-flex items-center gap-2 text-sm font-semibold text-ink-soft hover:text-terracotta transition-colors"
          >
            <ArrowLeft size={16} weight="bold" />
            Back to Home
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1 className="font-display font-bold tracking-tight text-4xl md:text-5xl text-ink">
            {title}
          </h1>
          <p className="mt-4 text-sm tracking-[0.2em] uppercase font-bold text-terracotta">
            Last updated: {updated}
          </p>
        </motion.div>

        <div className="mt-14 space-y-12">
          {sections.map((s, i) => (
            <motion.section
              key={s.heading}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: Math.min(i * 0.05, 0.3) }}
            >
              <h2 className="font-display font-bold tracking-tight text-xl md:text-2xl text-ink flex gap-4">
                <span className="font-serif italic text-terracotta font-medium">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {s.heading}
              </h2>
              <div className="mt-4 space-y-4 text-base leading-relaxed text-ink-soft md:pl-12">
                {s.body.map((p) => (
                  <p key={p.slice(0, 32)}>{p}</p>
                ))}
              </div>
            </motion.section>
          ))}
        </div>

        <p className="mt-16 pt-8 border-t border-black/10 text-sm text-ink-soft/70">
          Questions about this page? Email us at{" "}
          <a href="mailto:michelle@networkincolors.com" className="text-terracotta font-semibold hover:underline">
            michelle@networkincolors.com
          </a>
          .
        </p>
      </main>
    </div>
  );
};

export default LegalPage;
